import React, { useEffect, useState, Fragment } from "react";
import { useDispatch } from "react-redux";
import {
  getSyncFields,
  hubspotDeleteData,
  postSyncFields,
} from "../../redux/actions/settingActions";
import { fetchLeadListing } from "../../redux/actions/chatAiActions"
import { useSelector } from "react-redux";
import * as Icon from "react-bootstrap-icons";
import { FaArrowRight } from "react-icons/fa";
import Toast from "../assetLibComponents/shared/Toast";
import { Dialog, Transition, Menu } from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";

const SettingSyncField = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const fData = useSelector((state) => state.setting.fieldsData);
  const hubspotDeleteCheck = useSelector(
    (state) => state.setting.hubspotDeleteData
  );
  const [selectedItems, setSelectedItems] = useState(fData?.hubspot_fields);
  const [searchTerm, setSearchTerm] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteContent, setDeleteContent] = useState("");
  const preSelectedItems = [
    "firstname/leads",
    "email/leads",
    "phone/leads",
    "city/leads",
    "state/leads",
    "country/leads",
    "jobtitle/leads",
    "domain/accounts",
    "name/accounts"   
]


  const handleItemClick = (item) => {
    if (
      !selectedItems.some((it) => it?.fieldId === item?.fieldId)
    ) {
      setSelectedItems([...selectedItems, item]);
    }
  };

  const isNamePresent = (arr, obj) => {
    const objName = obj.fieldId    ;
    return arr.some((item) => item.fieldId === objName);
  };
  // hubspot_map_fields
  // progressive_profile_fields
  const handleDeleteClick = (item) => {
    if (isNamePresent(hubspotDeleteCheck?.hubspot_map_fields, item)) {
      setDeleteModal(true);
      setDeleteContent(
        "The field you are trying to delete is currently in use in a progressive profiling widget or is mapped against a Zoi field. Please check and remove any existing associations to ensure proper data flow."
      );
    } else {
      const updatedItems = selectedItems.filter(
        (selectedItem) => selectedItem !== item
      );
      setSelectedItems(updatedItems);
    }
  };

  const filteredData = fData?.fields_list?.filter((item) =>
    item.label.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const handleCloseSearch = () => {
    setSearchTerm("");
  };

  useEffect(() => {
    dispatch(getSyncFields(props.authToken));
    dispatch(hubspotDeleteData(props.authToken));
  }, []);

  const handleSubmit = async () => {
    if (selectedItems?.length == 0) {
      Toast("Please select atleast 1 field", "E");
    } else {
      await dispatch(fetchLeadListing(props.authToken, "pass"));
      await dispatch(postSyncFields(props.authToken, selectedItems));
      await navigate("/Setting/hubspot");
    }
  };


  return (
    <div>
      <div className="flex justify-between mb-2 border-b border-gray-200 pb-4">
        <div className="text-lg leading-7 font-[500] my-auto">
          Field Selection
        </div>
        <div className="flex items-center">
            <button
              onClick={()=>{navigate("/Setting/hubspot")}}
              type="button"
              className="mr-4 inline-flex border border-gray-300 items-center gap-x-1.5 rounded-md bg-transparent hover:bg-[#bcc2c3] px-3 py-2 text-sm font-semibold text-gray-700 shadow-sm"
            >
              <Icon.ChevronLeft className="text-[#000000]"/> <span>Back</span>
            </button>
            <button
              onClick={handleSubmit}
              type="button"
              className="mr-4 inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] px-3 py-2 text-sm font-semibold text-white shadow-sm"
            >
              Save Changes
            </button>
          </div>
      </div>
      {fData && (
        <div className="max-sm:w-full max-sm:overflow-auto">
          <div className="grid grid-cols-10 max-sm:w-[800px]">
            <div className="col-span-4 mt-3">
              <div className="font-[600] px-8 text-base">Available Items</div>
              <div className="rounded-2xl bg-white px-8 py-4 mt-2">
                <div className="relative rounded-md shadow-sm my-auto ">
                  <input
                    type="text"
                    placeholder="Search by name"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="block w-full rounded-md border-0 py-1.5 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-300 sm:text-sm sm:leading-6"
                  />
                  <div className="absolute z-[9] cursor-pointer right-[5%] top-1/4">
                    {searchTerm && searchTerm !== "" ? (
                      <Icon.X
                        className="h-4 w-4 text-gray-400 pointer"
                        onClick={handleCloseSearch}
                      />
                    ) : (
                      <Icon.Search className="h-4 w-4 text-gray-400 cursor-pointer" />
                    )}
                  </div>
                </div>
                <ul className="h-[50vh] overflow-auto syncField mt-4 px-2">
                  {filteredData?.map((item, index) => (
                    <div
                      onClick={() => handleItemClick(item)}
                      className="flex cursor-pointer my-2 p-3 rounded-md bg-white border border-1 shadow-md"
                    >
                      <li title={item?.label} key={index}>{item?.label?.length > 25 ? `${item?.label.slice(0,25)}...`: item?.label}<span key={index} className="rounded-md bg-blue-100 px-2 py-1 my-auto text-xs font-medium text-blue-700 ml-3">{item?.object_type === "leads" ? "Leads" :"Accounts"} </span>
</li>
                      {selectedItems?.some(
                        (it) => it?.fieldId === item?.fieldId
                      ) && <Icon.Check className="ml-auto my-auto text-lg" />}
                    </div>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-span-2 m-auto">
              <FaArrowRight className="text-gray-400 border border-solid border-gray-400 p-1 text-2xl" />
            </div>
            <div className="col-span-4 mt-3 ">
              <div className="font-[600] px-8 text-base">Selected Items</div>
              <div className="rounded-2xl bg-white px-8 py-4 mt-2 ">
                <ul className="h-[56vh] overflow-auto syncField mt-4 px-2">
                  {selectedItems?.map((item, index) => (
                    <div className="flex cursor-pointer my-2 p-3 rounded-md bg-white border border-1 shadow-md">
                     <li title={item?.label} key={index}>{item?.label?.length > 25 ? `${item?.label.slice(0,25)}...`: item?.label}<span key={index} className="rounded-md bg-blue-100 px-2 py-1 my-auto text-xs font-medium text-blue-700 ml-3">{item?.object_type === "leads" ? "Leads" :"Accounts"} </span></li>
                     {!preSelectedItems?.includes(item?.fieldId)  && <Icon.Trash
                        className="ml-auto my-auto text-lg"
                        onClick={() => handleDeleteClick(item)}
                      />}
                    </div>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
      <Transition.Root show={deleteModal} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => {
            setDeleteModal(false);
          }}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                  <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                    <div className="sm:flex sm:items-start">
                      <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                        <ExclamationTriangleIcon
                          className="h-6 w-6 text-red-600"
                          aria-hidden="true"
                        />
                      </div>
                      <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                        <Dialog.Title
                          as="h3"
                          className="text-base font-semibold leading-6 text-gray-900"
                        >
                          Delete Field
                        </Dialog.Title>
                        <div className="mt-2">
                          <p className="text-sm text-gray-500">
                            {deleteContent}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                    <button
                      type="button"
                      className="inline-flex w-full justify-center rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] sm:ml-3 sm:w-auto outline-none border-none"
                      onClick={() => {
                        setDeleteModal(false);
                      }}
                    >
                      OK
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default SettingSyncField;
